import { styled } from '@creditas-ui/system'

const Container = styled.div``

export { Container }
